import Ajax from '../../../../util/ajax';
export function zigbeeUnlockDoor(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/0x0101/command/unlock-door';
        const value = {
            'code': payload.code
        };
        ajax.post(url, value);
    };
}
